import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import SectionContainer from '../LandingPage/components/section/SectionContainer'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none">
    <circle cx="9.5" cy="10.5" r="5.5" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z"
      fill="#5CBB90"
    />
  </svg>
)

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path d="M15 10.5V3.5V3H17L23 9V10.5H15Z" fill="#D4DAE0" />
    <path
      d="M5 18L7.5 22.2H22V25H8C6.34315 25 5 23.6569 5 22V18Z"
      fill="#D4DAE0"
    />
    <path
      d="M4.25 22V6C4.25 5.00544 4.64537 4.05189 5.34863 3.34863C6.05189 2.64537 7.00544 2.25 8 2.25H16.5C16.9641 2.25 17.4091 2.43451 17.7373 2.7627L23.2373 8.2627C23.5655 8.59088 23.75 9.03587 23.75 9.5V22C23.75 22.9322 23.4029 23.8287 22.7803 24.5166L22.6514 24.6514C21.9481 25.3546 20.9946 25.75 20 25.75H8C7.06776 25.75 6.17125 25.4029 5.4834 24.7803L5.34863 24.6514C4.64537 23.9481 4.25 22.9946 4.25 22ZM5.75 22C5.75 22.5967 5.98722 23.1689 6.40918 23.5908L6.57422 23.7402C6.9746 24.0683 7.47785 24.25 8 24.25H20C20.5967 24.25 21.1689 24.0128 21.5908 23.5908L21.7402 23.4258C22.0683 23.0254 22.25 22.5221 22.25 22V9.5C22.25 9.43369 22.2236 9.37013 22.1768 9.32324L16.6768 3.82324C16.6299 3.77636 16.5663 3.75 16.5 3.75H8C7.40326 3.75 6.83114 3.98722 6.40918 4.40918C5.98722 4.83114 5.75 5.40326 5.75 6V22Z"
      fill="#474C5E"
    />
    <path
      d="M14.25 10V4C14.25 3.0335 15.0335 2.25 16 2.25C16.4142 2.25 16.75 2.58579 16.75 3C16.75 3.41421 16.4142 3.75 16 3.75C15.8619 3.75 15.75 3.86193 15.75 4V10C15.75 10.1381 15.8619 10.25 16 10.25H22C22.1381 10.25 22.25 10.1381 22.25 10C22.25 9.58579 22.5858 9.25 23 9.25C23.4142 9.25 23.75 9.58579 23.75 10C23.75 10.9665 22.9665 11.75 22 11.75H16C15.0335 11.75 14.25 10.9665 14.25 10Z"
      fill="#474C5E"
    />
    <path
      d="M16.3996 17C16.3996 16.8515 16.3851 16.7052 16.3586 16.5615C16.3122 16.3105 16.4297 16.057 16.6515 15.9307L16.798 15.8467C16.9657 15.7503 17.0379 15.5514 16.9797 15.375L16.9465 15.3008C16.85 15.1333 16.6504 15.0617 16.4738 15.1201L16.3996 15.1533L16.2463 15.2412C16.0263 15.3673 15.7505 15.3415 15.5578 15.1768C15.3368 14.9878 15.0802 14.8387 14.799 14.7393C14.5595 14.6544 14.3996 14.428 14.3996 14.1738V14C14.3996 13.8068 14.2624 13.6458 14.0802 13.6084L13.9992 13.5996C13.7782 13.5999 13.5998 13.7796 13.5998 14V14.1738C13.5998 14.428 13.439 14.6544 13.1994 14.7393C12.9181 14.8388 12.6622 14.988 12.4416 15.1768C12.2489 15.3416 11.9731 15.3672 11.7531 15.2412L11.5998 15.1533H11.5988C11.4312 15.0572 11.2229 15.0957 11.0998 15.2354L11.0529 15.3008C10.9431 15.4919 11.0089 15.7364 11.2004 15.8467H11.1994L11.3478 15.9316C11.569 16.0582 11.6861 16.3109 11.6398 16.5615C11.6133 16.7051 11.5998 16.8516 11.5998 17C11.5998 17.1479 11.6133 17.2945 11.6398 17.4385C11.6857 17.6879 11.5702 17.9394 11.3508 18.0664L11.2023 18.1523L11.2004 18.1533C11.0091 18.2635 10.9431 18.5079 11.0529 18.6992L11.0998 18.7646C11.223 18.9044 11.4313 18.9429 11.5988 18.8467L11.7502 18.7588L11.8351 18.7188C12.0385 18.6402 12.2722 18.6772 12.4416 18.8223C12.6621 19.011 12.9178 19.16 13.1994 19.2598C13.439 19.3446 13.5998 19.571 13.5998 19.8252V20C13.5998 20.2204 13.7782 20.4001 13.9992 20.4004L14.0802 20.3916C14.2624 20.3542 14.3996 20.1932 14.3996 20V19.8252C14.3996 19.5711 14.5595 19.3446 14.799 19.2598C15.0804 19.1602 15.337 19.0112 15.5578 18.8223L15.634 18.7666C15.8195 18.6528 16.0556 18.6473 16.2482 18.7588L16.3996 18.8467L16.4738 18.8799C16.6504 18.9383 16.85 18.8667 16.9465 18.6992L16.9797 18.625C17.0295 18.4736 16.984 18.3057 16.8644 18.2002L16.799 18.1533L16.6496 18.0674C16.4292 17.9407 16.3126 17.6885 16.3586 17.4385C16.3851 17.2945 16.3996 17.148 16.3996 17ZM14.3996 17C14.3996 16.9321 14.3819 16.8715 14.3547 16.8184L14.342 16.7969C14.3402 16.7938 14.3386 16.7908 14.3371 16.7881C14.2831 16.7026 14.2003 16.6394 14.1027 16.6133L13.9992 16.5996C13.8586 16.5998 13.7336 16.6731 13.6613 16.7881L13.6574 16.7969C13.6528 16.805 13.6477 16.812 13.6437 16.8184C13.6156 16.8732 13.5998 16.9344 13.5998 17C13.5998 17.0649 13.6153 17.1246 13.6418 17.1777L13.6574 17.2031L13.6603 17.209C13.7322 17.3252 13.8574 17.4002 13.9992 17.4004L14.1037 17.3867C14.202 17.3602 14.2844 17.2954 14.3381 17.209C14.3392 17.207 14.3408 17.2052 14.342 17.2031L14.3527 17.1846C14.3815 17.1298 14.3996 17.0682 14.3996 17ZM15.4015 17.7646L15.4006 17.7666C15.3997 17.7685 15.3984 17.7718 15.3967 17.7754C15.3949 17.779 15.3918 17.7834 15.3888 17.7891C15.3927 17.7819 15.3966 17.7765 15.3986 17.7725L15.4025 17.7637L15.4015 17.7646ZM13.6838 17.2539C13.6834 17.2531 13.6828 17.2512 13.6818 17.249C13.6806 17.2465 13.6784 17.2429 13.676 17.2383L13.6838 17.2539ZM14.3771 16.8516L14.3761 16.8496C14.3755 16.8487 14.3743 16.8473 14.3732 16.8457C14.3751 16.8486 14.3765 16.8506 14.3771 16.8516ZM15.5998 17C15.5998 17.2744 15.5295 17.5346 15.4064 17.7617C15.4012 17.7713 15.3956 17.7807 15.3898 17.79C15.3858 17.7966 15.3816 17.8018 15.3791 17.8057L15.3801 17.8066C15.3765 17.813 15.3731 17.82 15.3693 17.8262C15.1253 18.2301 14.7056 18.5199 14.214 18.5859L13.9992 18.5996C13.4162 18.5994 12.9086 18.2873 12.6301 17.8262C12.6266 17.8205 12.6235 17.8144 12.6203 17.8086C12.6168 17.8033 12.6127 17.7968 12.6086 17.79C12.6028 17.7807 12.5972 17.7713 12.592 17.7617C12.4692 17.5349 12.3996 17.2744 12.3996 17C12.3996 16.724 12.4701 16.4637 12.5929 16.2373L12.6095 16.209H12.6115C12.6128 16.2066 12.6143 16.2031 12.6164 16.1992C12.6141 16.2032 12.6119 16.2064 12.6105 16.209H12.6095L12.6261 16.1826C12.6285 16.1785 12.6305 16.174 12.633 16.1699C12.912 15.7115 13.418 15.4006 13.9992 15.4004L14.2131 15.4141C14.6333 15.4703 15.0007 15.6902 15.2511 16.0049L15.3664 16.1699L15.3801 16.1924L15.3908 16.209L15.4064 16.2373C15.5304 16.4657 15.5998 16.7263 15.5998 17ZM17.5998 17C17.5998 17.0827 17.5947 17.1643 17.589 17.2451C18.1608 17.6948 18.3604 18.4809 18.0617 19.1504L17.9875 19.2969C17.5854 19.9965 16.7344 20.2765 16.006 19.9844C15.8702 20.0756 15.7281 20.1573 15.5802 20.2295C15.4764 20.951 14.8939 21.5175 14.1633 21.5918L13.9992 21.5996C13.1941 21.5993 12.5286 21.0043 12.4172 20.2295C12.2694 20.1573 12.1272 20.0756 11.9914 19.9844C11.3131 20.2557 10.5297 20.0321 10.1008 19.4346L10.0119 19.2969C9.61181 18.5999 9.79549 17.7283 10.4084 17.2451C10.4027 17.1643 10.3996 17.0826 10.3996 17C10.3996 16.9171 10.4027 16.8351 10.4084 16.7539C9.79591 16.2707 9.61163 15.4001 10.0119 14.7031L10.1008 14.5654C10.5295 13.9683 11.3125 13.7442 11.9904 14.0146C12.1265 13.9232 12.269 13.8409 12.4172 13.7686C12.5294 12.9946 13.1947 12.4007 13.9992 12.4004L14.1633 12.4082C14.8933 12.4825 15.4757 13.0479 15.5802 13.7686C15.7285 13.8409 15.8709 13.9232 16.007 14.0146C16.7352 13.7233 17.5856 14.0039 17.9875 14.7031L18.0617 14.8486C18.361 15.5183 18.1606 16.304 17.589 16.7539C17.5947 16.8351 17.5998 16.9171 17.5998 17Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M23 20C25 17.2 25.1667 13.5 25 12L24.5 5C24 15.5 20 20 9.5 24C15.5 29 21 22.8 23 20Z"
      fill="#D4DAE0"
    />
    <path
      d="M24.25 5.66719C24.25 5.51526 24.1676 5.37691 24.0381 5.30391L23.9795 5.27656L14.6465 1.77656C14.5757 1.75001 14.4993 1.74372 14.4258 1.75703L14.3535 1.77656L5.02051 5.27656C4.85788 5.33755 4.75 5.4935 4.75 5.66719V13.8332C4.75 17.519 7.20012 20.542 9.55859 22.6057L10.0039 22.9846C11.0388 23.8445 12.0442 24.5292 12.8213 25.0148L13.4277 25.383C13.6087 25.4891 13.767 25.5784 13.8975 25.6506C14.0275 25.7226 14.1303 25.7774 14.2012 25.8146L14.2812 25.8566H14.2822L14.3047 25.8684L14.3096 25.8713H14.3105L14.3125 25.8723L14.4043 25.9055C14.497 25.9273 14.595 25.9163 14.6816 25.8742C14.6832 25.8734 14.685 25.8731 14.6865 25.8723L14.6895 25.8713H14.6904L14.6953 25.8684L14.7178 25.8566C14.7366 25.847 14.7641 25.8329 14.7988 25.8146L15.1025 25.6506C15.3633 25.5062 15.7343 25.2926 16.1787 25.0148L16.8965 24.551C17.6604 24.0388 18.5504 23.3853 19.4414 22.6057C21.7999 20.542 24.25 17.519 24.25 13.8332V5.66719ZM25.75 13.8332C25.75 18.1891 22.8763 21.5929 20.4287 23.7346C19.4806 24.5642 18.5373 25.2562 17.7305 25.7971L16.9746 26.2873C16.505 26.5808 16.1102 26.8075 15.8291 26.9631L15.4961 27.1428C15.456 27.1638 15.4237 27.1807 15.4004 27.1926L15.3984 27.1936L15.374 27.2063L15.3711 27.2072L15.3633 27.2111L15.3623 27.2121L15.3604 27.2131L15.29 27.2443C15.2856 27.246 15.2808 27.2466 15.2764 27.2482C14.7542 27.4802 14.1555 27.4704 13.6426 27.2141L13.6406 27.2131L13.6377 27.2121L13.6367 27.2111L13.6289 27.2072L13.626 27.2063L13.6016 27.1936L13.5996 27.1926L13.5039 27.1428C13.4238 27.1007 13.3112 27.0408 13.1709 26.9631C13.0304 26.8853 12.8613 26.7898 12.6689 26.677L12.0254 26.2873C11.0902 25.7028 9.83534 24.8406 8.57129 23.7346C6.12371 21.5929 3.25 18.1891 3.25 13.8332V5.66719C3.25 4.86824 3.74606 4.1528 4.49414 3.87227L13.8271 0.372267L13.9912 0.318556C14.3794 0.211688 14.7931 0.22989 15.1729 0.372267L24.5059 3.87227L24.6436 3.92988C25.3144 4.24253 25.75 4.91817 25.75 5.66719V13.8332Z"
      fill="#474C5E"
    />
    <path
      d="M18.1768 10.418C18.4714 10.1779 18.9062 10.1952 19.1807 10.4697C19.4733 10.7625 19.4733 11.2374 19.1807 11.5303L14.5137 16.1973C13.8118 16.899 12.7011 16.9425 11.9483 16.3281L11.8028 16.1973L9.46976 13.8633L9.418 13.8066C9.17786 13.5121 9.19521 13.0773 9.46976 12.8027C9.74447 12.5282 10.1791 12.5114 10.4737 12.7519L10.5303 12.8027L12.8633 15.1367C13.026 15.2994 13.2904 15.2993 13.4532 15.1367L18.1192 10.4697L18.1768 10.418Z"
      fill="#474C5E"
    />
  </svg>
)

const SafeguardSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('solutions:safeguard:section_1_content_title'),
      iconType: ICON_1,
      contentDescription: t(
        'solutions:safeguard:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionSafeguard01.png',
      contentLink: '#'
    },
    {
      contentTitle: t('solutions:safeguard:section_2_content_title'),
      iconType: ICON_2,
      contentDescription: t(
        'solutions:safeguard:section_2_content_description'
      ),
      contentBox01: t('solutions:safeguard:section_2_content_box01'),
      contentBox02: t('solutions:safeguard:section_2_content_box02'),
      contentBox03: t('solutions:safeguard:section_2_content_box03'),
      contentImage: '/img/feature/lp/new/solutionSafeguard02.png',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="solutions:safeguard:title"
      // tagLabel="solutions:safeguard:tag"
      // tagColor="bg-purple-100 text-purple-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-row tablet:flex-wrap align-middle w-full justify-center mt-6 border-gray-100 border border-r-0 border-b-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 border-gray-100 border-r border-b min-w-[50%] relative p-8">
              <div className="absolute right-[18px] top-[18px]">
                {item.iconType}
              </div>
              <TypographyText className="text-[23px] font-medium text-gray-900">
                {item.contentTitle}
              </TypographyText>
              <TypographyText className="text-base font-normal text-gray-700 mt-1.5">
                {item.contentDescription}
              </TypographyText>
              {item.contentBox01 || item.contentBox02 || item.contentBox03 ? (
                <div className="mt-1.5 space-y-1.5">
                  {item.contentBox01 ? (
                    <div className="flex items-center space-x-3">
                      {ICON}
                      <TypographyText className="text-base text-gray-700 font-normal">
                        {item.contentBox01}
                      </TypographyText>
                    </div>
                  ) : null}
                  {item.contentBox02 ? (
                    <div className="flex items-center space-x-3">
                      {ICON}
                      <TypographyText className="text-base text-gray-700 font-normal">
                        {item.contentBox02}
                      </TypographyText>
                    </div>
                  ) : null}
                  {item.contentBox03 ? (
                    <div className="flex items-center space-x-3">
                      {ICON}
                      <TypographyText className="text-base text-gray-700 font-normal">
                        {item.contentBox03}
                      </TypographyText>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="mt-1.5 tablet:h-[84px]" />
              )}
              <div className="mt-12">
                <Image
                  src={item.contentImage}
                  width={544}
                  height={0}
                  alt={`${item.contentImage}-image`}
                  className="h-auto"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default SafeguardSection
